<ul class="no-list-style">
  @for (item of items(); track $index; let first = $first; let last = $last) {
    <li>
      <button
        #rowButton
        type="button"
        (click)="clicked.emit($index)"
        class="flight-summary flex fill ps-small border"
        [class.rounded-top-large]="first && !last"
        [class.rounded-bottom-large]="!first && last"
        [class.rounded-large]="first && last"
        [class.first]="first"
        [attr.aria-label]="item.ariaLabel || null"
      >
        <div class="flex-1 align-left">
          <span class="bold-type">{{ item.label }},</span>
          <span class="ps-xxsmall-l">{{ item.date }}</span>
        </div>
        <div class="flex-1 align-right">
          <span>
            <span class="medium-type">{{ item.departure.time }}</span>
            <span class="ps-xsmall-x">{{ item.departure.location }}</span>
          </span>
          <span class="ps-xsmall-r">-</span>
          <span>
            <span class="medium-type">{{ item.arrival.time }}</span>
            <span class="ps-xsmall-x">{{ item.arrival.location }}</span>
          </span>
          <fcom-icon [name]="SvgLibraryIcon.CHECKMARK" />
        </div>
      </button>
    </li>
  }
</ul>
